export enum ChannelsEnum {
  TELEFONE = '1',
  EMAIL = '2',
  WHATSAPP = '3',
  CHAT = '4'
}

export interface ChannelsInterface {
  id: string;
  description: string;
}
export class Channels {

  private channels = [
    {
      id: ChannelsEnum.TELEFONE,
      description: 'Telefone'
    },
    {
      id: ChannelsEnum.EMAIL,
      description: 'Email'
    },
    {
      id: ChannelsEnum.WHATSAPP,
      description: 'Whatsapp'
    },
    {
      id: ChannelsEnum.CHAT,
      description: 'Chat'
    }
  ];

  values() {
    return [].concat(this.channels);
  }

  withoutChat() {
    return [].concat(
      this.channels.filter(item => item.id !== ChannelsEnum.CHAT)
    );
  }

  channelById(id: string): string {
    const channel = this.channels.find(item => item.id === id);
    return channel && channel.description;
  }

  getSpecificItems(options: Array<string>): Array<ChannelsInterface> {
    return this.channels.filter(item => !options.includes(item.id));
  }
}


